import { BundleRequestService } from 'app/_services/bundle-request.service';
import { Growl } from 'angular/custom/services/growl.service';
import * as angular from 'angular';

class NetworkPointBundleCreateAuctionSettingCtrl implements ng.IController {
    public isCreateMode: boolean;
    public readonly: boolean;
    public exitNetworkPoint: NetworkPointDto;
    public entryNetworkPoint: NetworkPointDto;
    public exitMatchOrder: CapacityCategory[];
    public entryMatchOrder: CapacityCategory[];
    public auctionAlgorithmType: AuctionAlgorithmType;
    public editableDirection: Direction;
    public useShortTermForLongTerm: boolean;
    public slotAssignments: BundleChangeRequestSlotAssignmentDto[];
    public newSlotAssignmentBundled: BundleChangeRequestSlotAssignmentDto =
        null;
    public newSlotAssignmentExit: BundleChangeRequestSlotAssignmentDto = null;
    public newSlotAssignmentEntry: BundleChangeRequestSlotAssignmentDto = null;
    public auctionSlots: number[] = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25
    ];

    constructor(
        private bundleRequestService: BundleRequestService,
        private $filter: ng.IFilterService,
        private $translate: ng.translate.ITranslateService,
        private growl: Growl
    ) {}

    $onInit() {
        this.initMatchingOrder();
    }

    public onOrderChanged() {
        this.sortAssignmentsWithMatchingOrder();
    }

    public initMatchingOrder() {
        if (this.readonly) {
            return;
        }
        if (
            this.isCreateMode ||
            this.editableDirection !== 'ENTRY' ||
            this.exitMatchOrder.length <
                this.exitNetworkPoint.capacityCategories0.length
        ) {
            angular.forEach(
                angular.copy(this.exitNetworkPoint.capacityCategories0),
                (category) => {
                    if (this.exitMatchOrder.indexOf(category) == -1) {
                        this.exitMatchOrder.push(category);
                    }
                }
            );
        }
        if (
            this.isCreateMode ||
            this.editableDirection !== 'EXIT' ||
            this.entryMatchOrder.length <
                this.entryNetworkPoint.capacityCategories0.length
        ) {
            angular.forEach(
                angular.copy(this.entryNetworkPoint.capacityCategories0),
                (category) => {
                    if (this.entryMatchOrder.indexOf(category) == -1) {
                        this.entryMatchOrder.push(category);
                    }
                }
            );
        }
    }

    public filterAuctionSlots(
        slot: BundleChangeRequestSlotAssignmentDto,
        direction: Direction,
        auctionAlgorithmType: AuctionAlgorithmType
    ) {
        return (slot: BundleChangeRequestSlotAssignmentDto) => {
            if (slot.auctionAlgorithmType == auctionAlgorithmType) {
                if (direction == 'BUNDLE') {
                    if (slot.exitCategory && slot.entryCategory) {
                        return true;
                    }
                } else {
                    if (
                        direction == 'EXIT' &&
                        slot.exitCategory &&
                        !slot.entryCategory
                    ) {
                        return true;
                    }
                    if (
                        direction == 'ENTRY' &&
                        !slot.exitCategory &&
                        slot.entryCategory
                    ) {
                        return true;
                    }
                }
            }
            return false;
        };
    }

    public filterAlreadyExistingUnbundledSlots(direction: Direction) {
        if (direction == 'EXIT') {
            return (type) => {
                return !this.bundleRequestService.slotAlreadyInSlotAssignments(
                    <BundleChangeRequestSlotAssignmentDto>{
                        exitCategory: type
                    },
                    this.slotAssignments,
                    this.auctionAlgorithmType,
                    direction
                );
            };
        }
        if (direction == 'ENTRY') {
            return (type) => {
                return !this.bundleRequestService.slotAlreadyInSlotAssignments(
                    <BundleChangeRequestSlotAssignmentDto>{
                        entryCategory: type
                    },
                    this.slotAssignments,
                    this.auctionAlgorithmType,
                    direction
                );
            };
        }
    }

    public addSlotAssignment(
        auctionAlgorithmType: AuctionAlgorithmType,
        direction: Direction
    ): void {
        if (direction == 'BUNDLE') {
            this.newSlotAssignmentBundled.auctionAlgorithmType =
                auctionAlgorithmType;
            if (
                !this.bundleRequestService.slotAlreadyInSlotAssignments(
                    this.newSlotAssignmentBundled,
                    this.slotAssignments,
                    this.auctionAlgorithmType,
                    direction
                )
            ) {
                if (
                    this.bundleRequestService.bundledCapacityCategoryDifferentInUnbundledSlotAssignments(
                        this.slotAssignments,
                        this.auctionAlgorithmType,
                        this.newSlotAssignmentBundled
                    )
                ) {
                    this.growl.show(
                        'At least one capacity category of the bundeld slot has already been configured as an unbundled slot with a different slot number.',
                        'danger'
                    );
                } else if (
                    this.bundleRequestService.bundledCapacityCategoryEmptyInUnbundledSlotAssignments(
                        this.slotAssignments,
                        this.auctionAlgorithmType,
                        this.newSlotAssignmentBundled
                    )
                ) {
                    this.growl.show(
                        'There is at least one unbundled slot configuration with an empty slot number. Please provide a valid slot number or remove the empty unbundled slot',
                        'danger'
                    );
                } else {
                    this.slotAssignments.push(this.newSlotAssignmentBundled);
                    this.newSlotAssignmentBundled = null;
                }
            } else {
                this.growl.show(
                    'Bundled auction slot already configured',
                    'danger'
                );
            }
        }
        if (direction == 'EXIT') {
            this.newSlotAssignmentExit.auctionAlgorithmType =
                auctionAlgorithmType;

            if (
                this.bundleRequestService.unbundledCapacityCategoryDifferentInBundledSlotAssignments(
                    this.slotAssignments,
                    auctionAlgorithmType,
                    direction,
                    this.newSlotAssignmentExit.exitCategory,
                    this.newSlotAssignmentExit.slot
                )
            ) {
                this.growl.show(
                    'Unbundled auction slot already in bundled slot order with a different slot number.',
                    'danger'
                );
            } else if (
                this.bundleRequestService.slotAlreadyInSlotAssignments(
                    this.newSlotAssignmentExit,
                    this.slotAssignments,
                    this.auctionAlgorithmType,
                    direction
                )
            ) {
                this.growl.show(
                    'Unbundled auction slot already configured',
                    'danger'
                );
            } else {
                this.slotAssignments.push(this.newSlotAssignmentExit);
                this.newSlotAssignmentExit = null;
            }
        }
        if (direction == 'ENTRY') {
            this.newSlotAssignmentEntry.auctionAlgorithmType =
                auctionAlgorithmType;

            if (
                this.bundleRequestService.unbundledCapacityCategoryDifferentInBundledSlotAssignments(
                    this.slotAssignments,
                    auctionAlgorithmType,
                    direction,
                    this.newSlotAssignmentEntry.entryCategory,
                    this.newSlotAssignmentEntry.slot
                )
            ) {
                this.growl.show(
                    'Unbundled auction slot already in bundled slot order with a different slot number.',
                    'danger'
                );
            } else if (
                this.bundleRequestService.slotAlreadyInSlotAssignments(
                    this.newSlotAssignmentEntry,
                    this.slotAssignments,
                    this.auctionAlgorithmType,
                    direction
                )
            ) {
                this.growl.show(
                    'Unbundled auction slot already configured',
                    'danger'
                );
            } else {
                this.slotAssignments.push(this.newSlotAssignmentEntry);
                this.newSlotAssignmentEntry = null;
            }
        }

        this.sortAssignmentsWithMatchingOrder();
    }

    public removeFromSlotAssignments(
        slot: BundleChangeRequestSlotAssignmentDto
    ): void {
        this.slotAssignments.splice(this.slotAssignments.indexOf(slot), 1);
    }

    public isSlotNumberAllowed(
        auctionAlgorithmType: AuctionAlgorithmType,
        capacityCategory: CapacityCategory,
        slotNumber: number,
        slotNumberOld: number,
        direction: Direction
    ): boolean {
        if (slotNumber <= 0 || angular.isUndefined(slotNumber)) {
            return true;
        }

        //determine the part of slotOrder that needs to be checked
        if (direction == 'EXIT' || direction == 'ENTRY') {
            let compareSlotsBundled = this.$filter('filter')(
                this.slotAssignments,
                {
                    auctionAlgorithmType: auctionAlgorithmType,
                    exitCategory: '!!',
                    entryCategory: '!!'
                }
            );

            angular.forEach(compareSlotsBundled, (slot) => {
                if (direction == 'EXIT') {
                    if (
                        slot.exitCategory == capacityCategory &&
                        slot.slot != slotNumber
                    ) {
                        this.growl.show(
                            'The unbundled slot number ' +
                                slotNumber +
                                ' for ' +
                                this.$translate.instant(
                                    'CapacityCategory.' + capacityCategory
                                ) +
                                ' is already configured as bundled slot number ' +
                                slot.slot +
                                '',
                            'danger'
                        );
                        return false;
                    }
                }

                if (direction == 'ENTRY') {
                    if (
                        slot.entryCategory == capacityCategory &&
                        slot.slot != slotNumber
                    ) {
                        this.growl.show(
                            'The unbundled slot number ' +
                                slotNumber +
                                ' for ' +
                                this.$translate.instant(
                                    'CapacityCategory.' + capacityCategory
                                ) +
                                ' is already configured as bundled slot number ' +
                                slot.slot +
                                '',
                            'danger'
                        );
                        return false;
                    }
                }
            });
        }
        // TODO: method always returns true! the following block does nothing? - see PRISMA-7480
        if (direction == 'BUNDLE') {
            let compareSlotsExit = this.$filter('filter')(
                this.slotAssignments,
                {
                    auctionAlgorithmType: auctionAlgorithmType,
                    exitCategory: '!!',
                    entryCategory: '!'
                }
            );
            let compareSlotsEntry = this.$filter('filter')(
                this.slotAssignments,
                {
                    auctionAlgorithmType: auctionAlgorithmType,
                    exitCategory: '!',
                    entryCategory: '!!'
                }
            );
        }
        return true;
    }

    public onChangeSlotNumber(
        auctionAlgorithmType: AuctionAlgorithmType,
        exitCategory: CapacityCategory,
        entryCategory: CapacityCategory,
        changedSlotNumber: number
    ) {
        let changesMade: boolean = false;

        angular.forEach(this.slotAssignments, (slot) => {
            if (
                slot.auctionAlgorithmType == auctionAlgorithmType &&
                !!changedSlotNumber
            ) {
                if (
                    slot.exitCategory == exitCategory &&
                    this.editableDirection === 'EXIT'
                ) {
                    slot.slot = changedSlotNumber;
                    changesMade = true;
                }

                if (
                    slot.entryCategory == entryCategory &&
                    this.editableDirection === 'ENTRY'
                ) {
                    slot.slot = changedSlotNumber;
                    changesMade = true;
                }
            }
        });

        if (changesMade) {
            this.growl.show(
                'Your change to the bundled slot order affect already configured unbundled slots. Unbundled slot are adjusteded accordingly. ' +
                    'If this change also affects unbundled slot configured by the counterparty these change will be part of a counterproposal.',
                'info',
                { delay: 5000 }
            );
        }

        //let indexExit = this.bundleRequest.slotAssignments.indexOf(this.$filter('filter')(this.bundleRequest.slotAssignments, {auctionAlgorithmType: auctionAlgorithmType}))
    }

    public sortAssignmentsWithMatchingOrder(): void {
        let filteredSlotAssignments = this.$filter('filter')(
            this.slotAssignments,
            { auctionAlgorithmType: this.auctionAlgorithmType }
        );
        let exitSlots: BundleChangeRequestSlotAssignmentDto[] = [];
        let entrySlots: BundleChangeRequestSlotAssignmentDto[] = [];
        let bundledSlots: BundleChangeRequestSlotAssignmentDto[] = [];

        angular.forEach(this.exitMatchOrder, (exitCategory) => {
            angular.forEach(filteredSlotAssignments, (slot) => {
                if (exitCategory == slot.exitCategory && !slot.entryCategory) {
                    exitSlots.push(slot);
                }
            });
        });

        angular.forEach(this.entryMatchOrder, (entryCategory) => {
            angular.forEach(filteredSlotAssignments, (slot) => {
                if (!slot.exitCategory && entryCategory == slot.entryCategory) {
                    entrySlots.push(slot);
                }
            });
        });

        angular.forEach(this.exitMatchOrder, (exitCategory) => {
            angular.forEach(this.entryMatchOrder, (entryCategory) => {
                angular.forEach(filteredSlotAssignments, (slot) => {
                    if (
                        exitCategory == slot.exitCategory &&
                        entryCategory == slot.entryCategory
                    ) {
                        bundledSlots.push(slot);
                    }
                });
            });
        });

        this.slotAssignments = exitSlots.concat(entrySlots, bundledSlots);
    }

    private getBundledSlotsFromSlotAssignments(
        auctionAlgorithmType: AuctionAlgorithmType
    ): BundleChangeRequestSlotAssignmentDto[] {
        return this.$filter('filter')(this.slotAssignments, {
            auctionAlgorithmType: auctionAlgorithmType,
            exitCategory: '!!',
            entryCategory: '!!'
        });
    }

    public isCapacityCategoryUsedInBundledSlotAssignments(
        direction: Direction,
        category: CapacityCategory
    ) {
        let filteredSlots = this.getBundledSlotsFromSlotAssignments(
            this.auctionAlgorithmType
        );
        if (filteredSlots.length) {
            for (let i = 0; i < filteredSlots.length; i++) {
                if (
                    direction == 'EXIT' &&
                    filteredSlots[i].exitCategory == category
                ) {
                    return true;
                }
                if (
                    direction == 'ENTRY' &&
                    filteredSlots[i].entryCategory == category
                ) {
                    return true;
                }
            }
        }
        return false;
    }
}

angular.module('app').component('pkpNetworkPointBundleCreateAuctionSetting', {
    controller: NetworkPointBundleCreateAuctionSettingCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-auction-setting.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        isCreateMode: '<',
        editableDirection: '<',
        auctionAlgorithmType: '<',
        exitNetworkPoint: '<',
        entryNetworkPoint: '<',
        useShortTermForLongTerm: '=',
        exitMatchOrder: '=',
        entryMatchOrder: '=',
        slotAssignments: '='
    }
});
